import AwarenessChannels from '@zola-helpers/client/dist/es/redux/userAwareness/userAwarenessChannelConstants';
import { awarenessChannelMap } from '@zola-helpers/client/dist/es/redux/userAwareness/userAwarenessHelpers';

type AwarenessChannelType = {
  displayText: string;
  isDisabled?: boolean;
};

export type AwarenessChannelMap = { [K in AwarenessChannels]: AwarenessChannelType };

export const getAwarenessChannelMap = (showSubwayOption?: boolean): AwarenessChannelMap => {
  if (showSubwayOption) {
    awarenessChannelMap[AwarenessChannels.SUBWAY].isDisabled = false;
  }
  return awarenessChannelMap;
};
